import React, { useState } from 'react'
import DateSelection from './DatePicker/DateSelection'
import dayjs from 'dayjs'

const AttractionsForm = ({
  widgetType,
  onChangePromoCode,
  onCalendarOpen,
  hidePromoField,
  values,
  setValues,
  submit,
  hasValidCart,
}) => {
  const [promoCodeOpen, setPromoCodeOpen] = useState(!!values.promoCode)

  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        submit()
      }}
    >
      <div className="row-group">
        <div className="input-label date-inputs">
          <DateSelection
            startDate={values.startDate}
            startDateLabel="Date"
            handleSelectDate={(key, date) => {
              const currentValues = { ...values }
              if (key === 'startDate') {
                currentValues.startDate = date
              }

              const endDate =
                !values.endDate ||
                dayjs(date).isAfter(dayjs(values.endDate), 'days')
                  ? date
                  : values.endDate

              setValues({
                ...currentValues,
                endDate,
              })
            }}
            isOneWay={true}
            widgetType={widgetType}
            onCalendarOpen={onCalendarOpen}
          />
        </div>
        {hidePromoField ? null : (
          <div className="promo-code">
            {promoCodeOpen || !!values.promoCode ? (
              <div className="input-label">
                <label>
                  <p>Promo Code</p>
                  <input
                    className=""
                    value={values.promoCode || ''}
                    onChange={e => onChangePromoCode(e.target.value)}
                    placeholder="Enter a Promo Code"
                    onBlur={e => setPromoCodeOpen(!!e.target.value)}
                  />
                </label>
              </div>
            ) : (
              <button type="button" onClick={() => setPromoCodeOpen(true)}>
                Add promo code +
              </button>
            )}
          </div>
        )}

        <button type="submit" className="btn-primary">
          {hasValidCart ? 'New Search' : 'Search'}
        </button>
      </div>
    </form>
  )
}

export default AttractionsForm
